import { comics } from "@/mocks/comics";
import ComicCard from "@/components/feature/ComicCard";
import { Link } from "react-router-dom";

export default function LatestUpdates() {
  const latestComics = comics.slice().sort(
    (a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()
  );

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1">
              每日新鲜内容，精彩不断更新
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5" data-product-shop="">
          {latestComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 px-6 py-2.5 bg-secondary-500 text-background-50 text-sm font-medium rounded-full hover:bg-secondary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看更多更新
            <i className="ri-arrow-down-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}